interface SelectBackofficeRouterParams {
  mode: string
  hiveUrl?: string
  optIn: unknown
}

interface BackofficeRouterSelection {
  router: 'apollo' | 'hive'
  url?: string
}

export const selectBackofficeRouter = ({
  mode,
  hiveUrl,
  optIn,
}: SelectBackofficeRouterParams): BackofficeRouterSelection => {
  if (mode !== 'development' || optIn === false || !hiveUrl) return { router: 'apollo' }

  return { router: 'hive', url: hiveUrl }
}
